import { styled as t, excludeProps as n, modifier as e, css as r } from "@lokalise/styled";
import { spacing as i, value as o } from "../../utils/theme/index.js";
import { withInputFieldStyle as d, withInputContainerStyle as s, withInputSizeVariants as p } from "../../utils/styles/inputStyle.js";
import { Flex as l } from "../Flex/Flex.js";
const m = t.div`
	width: 100%;
	display: grid;
	gap: ${i(1)};
	grid-template-columns: minmax(50px, 1fr); /* This ensures Input doesn't overflow 100% */
`, a = t.input.withConfig({ shouldForwardProp: n(["error"]) })`
	${d};

	border: 0;
	min-width: 50px;
	width: 100%;
	padding: 0;
	display: block;
`;
t.div`
	line-height: 1;
	font-size: 0;
`;
const x = t(l).withConfig({
  shouldForwardProp: n(["inputSize", "hasPrefix", "hasSuffix", "disabled", "error"])
})`
	${s};
	${p};

	align-items: center;
	padding: ${i(0, 3)};
	color: ${o("color.text.input.placeholder")};

	&:focus-within,
	[data-dev-state='focus'] & {
		color: ${o("color.border.active")};
	}

	// All items should preserve their width
	> * {
		flex-shrink: 0;
	}

	// Except input
	> ${a} {
		flex-shrink: 1;
	}

	${e(
  "hasPrefix",
  r`
			padding-left: ${i(2)};
		`
)};

	${e(
  "hasSuffix",
  r`
			padding-right: ${i(2)};
		`
)};
`;
export {
  m as Container,
  x as InputContainer,
  a as StyledInput
};
//# sourceMappingURL=styles.js.map
